import {
	readButtonText,
	writeButtonText,
} from '@dealstack/frontend/shared/components/EmailTemplates/utils/buttonNode';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { useCurrentEditor } from '@tiptap/react';
import type { InspectorNodeContext } from '@react-email/editor/ui';

interface Props {
	ctx: InspectorNodeContext;
}

export const ButtonProperties = ({ ctx }: Props) => {
	const tMipManage = useTranslationMipManage();
	const { editor } = useCurrentEditor();

	if (!editor) {
		return null;
	}

	const textLabel = tMipManage('email_templates.editor.button.text', {
		defaultValue: 'Button text',
	});
	const urlLabel = tMipManage('email_templates.editor.button.href', {
		defaultValue: 'Destination URL',
	});

	return (
		<>
			<div data-re-inspector-prop-row="">
				<label data-re-inspector-label="">{textLabel}</label>
				<input
					data-re-inspector-input=""
					data-grow=""
					type="text"
					aria-label={textLabel}
					value={readButtonText(editor, ctx.nodePos.pos)}
					onChange={(event) =>
						writeButtonText(editor, ctx.nodePos.pos, event.currentTarget.value)
					}
				/>
			</div>
			<div data-re-inspector-prop-row="">
				<label data-re-inspector-label="">{urlLabel}</label>
				<input
					data-re-inspector-input=""
					data-grow=""
					type="text"
					aria-label={urlLabel}
					title={String(ctx.getAttr('href') ?? '')}
					value={String(ctx.getAttr('href') ?? '')}
					onChange={(event) => ctx.setAttr('href', event.currentTarget.value)}
				/>
			</div>
		</>
	);
};
